<template>
  <v-card>
    <v-form v-model="formValid" ref="form">
      <v-container style="overflow-y: auto">
        <v-row>
          <v-col :cols="isRemote ? 12 : 7">
            <v-row dense>
              <v-col cols="4">
                <v-img :src="imageUrl" class="grey lighten-2"></v-img>
                <input
                  type="file"
                  style="display: none"
                  ref="image"
                  accept="image/*"
                  @change="onFilePicked"
                />
                <v-btn block class="primary" @click="$refs.image.click()">
                  <v-icon left>mdi-camera</v-icon>
                  {{ $t("common.edit") }}
                </v-btn>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="newEvent.name"
                  :label="this.$t('common.name')"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
                <!--<v-textarea
                  name="input-7-1"
                  rows="2"
                  v-model="newEvent.description"
                  :label="this.$t('common.description')"
                ></v-textarea>-->
              </v-col>

              <v-col cols="12">
                <div style="height: 200px">
                  <quill-editor
                    class="editor"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @ready="onEditorReady"
                  />
                </div>
              </v-col>
              <h4>
                {{ newEvent.hotel ? $t("common.checkIn") : $t("common.date") }}
              </h4>
              <v-col cols="12">
                <v-row v-if="newEvent.hotel" no-gutters>
                  <v-col cols="6" class="pr-4">
                    <DatePickerField v-model="eventDate" />
                  </v-col>

                  <v-col cols="6">
                    <TimePickerField v-model="eventTime" :rules="[rules.required]" />
                  </v-col>

                  <v-col cols="12">
                    <h4>{{ $t("common.checkOut") }}</h4>
                  </v-col>
                  <v-col cols="6" class="pr-4">
                    <DatePickerField v-model="checkOutDate" />
                  </v-col>

                  <v-col cols="6">
                    <TimePickerField v-model="checkOutTime" :rules="[rules.required]" />
                  </v-col>
                </v-row>

                <v-row v-else no-gutters>
                  <v-col cols="12" sm="4" class="pr-4">
                    <DatePickerField v-model="eventDate" />
                  </v-col>

                  <v-col cols="6" sm="4">
                    <TimePickerField v-model="eventTime" :rules="[rules.required]" />
                  </v-col>
                  <v-col cols="6" sm="4" class="pl-5">
                    <TimePickerField
                      deletable="true"
                      v-model="eventDuration"
                      :label="this.$t('common.duration')"
                      icon="mdi-timer"
                      :format="'24hr'"
                    />
                  </v-col>
                  <v-col cols="6">
                    <h4>{{ $t("itinerary.NewEvent.eventType") }}</h4>
                    <v-radio-group
                      v-model="isRemote"
                      row
                      persistent-hint
                      :hint="
                        $t(
                          `itinerary.NewEvent.${
                            isRemote ? 'remoteEventHint' : 'presentialEventHint'
                          }`,
                        )
                      "
                    >
                      <v-radio
                        :label="$t('itinerary.NewEvent.presentialEvent')"
                        :value="false"
                      ></v-radio>
                      <v-radio
                        :label="$t('itinerary.NewEvent.remoteEvent')"
                        :value="true"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6" v-if="isRemote">
                    <v-autocomplete
                      :items="timeZones"
                      v-model="timezone"
                      item-text="city"
                      label="Event Time zone"
                      :rules="[rules.required]"
                      return-object
                    ></v-autocomplete>
                    <v-text-field
                      v-model="newEvent.meeting_url"
                      :label="$t('itinerary.NewEvent.meetingUrl')"
                      :rules="[rules.isUrl]"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="mt-1 py-0">
                <h4>Notifications</h4>
                <v-checkbox
                  color="primary"
                  class="ma-0"
                  v-model="newEvent.alarm"
                  :label="this.$t('common.alarm')"
                ></v-checkbox>
              </v-col>

              <v-col cols="6" class="mt-1 py-0">
                <h4>{{ $t("common.remindersHint") }}</h4>
                <v-select
                  class="ma-0 py-0"
                  :items="reminders"
                  v-model="newEvent.reminder"
                ></v-select>
              </v-col>
              <v-col v-if="!isRemote" cols="6" class="py-0">
                <v-checkbox
                  dense
                  class="ma-0"
                  color="primary"
                  persistent-hint
                  v-model="newEvent.attendance"
                  :label="$t('common.checkAttendance')"
                  :rules="[
                    !newEvent.attendance ||
                      (newEvent.attendance && this.newEvent.location.coordinates != null) ||
                      $t('common.rules.attendance'),
                  ]"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-checkbox
                  dense
                  color="primary"
                  class="ma-0"
                  persistent-hint
                  v-model="newEvent.feedback"
                  :label="$t('common.feedBackLabel')"
                  :rules="[
                    !newEvent.feedback ||
                      (newEvent.feedback && eventDuration != null) ||
                      this.$t('common.rules.feedbackFinalDuration'),
                  ]"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="!isRemote" cols="5">
            <p v-if="newEvent.location.address" class="white--text primary pa-2 ma-0 text-center">
              {{ newEvent.location.address }}
            </p>
            <img v-if="newEvent.location.coordinates" :src="mapboxStaticImage" width="100%" />
            <v-card v-else class="grey lighten-3 d-flex align-center" style="height: 60%">
              <v-card-text style="width: 100%">
                <h2 class="text-center">{{ $t("common.noLocation") }}</h2>
              </v-card-text>
            </v-card>

            <v-dialog v-model="mapDialog" width="600">
              <template v-slot:activator="{ on }">
                <v-btn block class="fill-height" color="primary" v-on="on">
                  <v-icon left>mdi-pencil</v-icon>
                  {{ $t("common.edit") }}
                </v-btn>
              </template>
              <v-card v-if="mapDialog">
                <div class="primary">
                  <v-btn
                    class="float-right mr-2 mt-1"
                    icon
                    color="white"
                    text
                    @click="mapDialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <p v-if="marker && marker.address" class="white--text pa-2 ma-0 text-center">
                    {{ marker.address }}
                  </p>
                </div>
                <MglMap
                  v-if="mapDialog"
                  :accessToken="accessToken"
                  :center.sync="mapCenter"
                  :zoom.sync="mapZoom"
                  style="width: 600px; height: 400px"
                  :mapStyle="mapStyle"
                  @load="mapLoaded"
                >
                  <MglMarker
                    v-if="marker"
                    anchor="bottom"
                    color="#9652ff"
                    :coordinates="marker.coordinates"
                  ></MglMarker>

                  <MglGeocoderControl
                    :accessToken="accessToken"
                    :mapboxgl="mapboxgl"
                    :marker="false"
                    @result="selectedItem"
                  />
                </MglMap>
                <v-card-actions>
                  <div class="flex-grow-1"></div>

                  <v-btn color="error" text @click="removePin"
                    >{{ this.$t("common.deletePin") }}
                  </v-btn>
                  <v-btn color="primary" @click="saveNewPoint">{{ $t("common.edit") }} </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <h4 class="mt-4">{{ $t("common.attendance") }}</h4>
            <v-radio-group v-model="newEvent.privacy" :hint="privacyHint" persistent-hint row grow>
              <v-radio
                v-for="type in privacy"
                :key="type.value"
                :label="type.text"
                :value="type.value"
              ></v-radio>
            </v-radio-group>
            <div class="mt-2" v-if="newEvent.privacy == 3">
              <h4>{{ $t("common.selectedUsers") }}</h4>
              <v-select
                multiple
                v-model="invitedUsers"
                :items="allUsers"
                item-text="name"
                item-value="id"
                :label="this.$t('common.attendance')"
                single-line
                @selected="doSomething($event)"
              ></v-select>
            </div>
            <div class="mt-2" v-if="newEvent.privacy == 3">
              <h4>{{ $t("itinerary.NewEvent.selectedSubgroups") }}</h4>
              <v-select
                multiple
                v-model="subgroups"
                :items="allSubgroups"
                item-text="name"
                item-value="id"
                :label="this.$t('navbar.menu.subgroups')"
                single-line
              ></v-select>
            </div>
          </v-col>
        </v-row>
        <p v-if="feedback" class="my-0 mr-4 red--text text-right">
          {{ feedback }}
        </p>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :text="editEvent != null"
          :color="editEvent ? 'primary' : 'error'"
          @click="handleDelete"
          >{{ editEvent ? $t("common.cancel") : $t("common.delete") }}
        </v-btn>
        <v-btn :disabled="!formValid" color="primary" :loading="saving" @click="handleSave"
          >{{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { format, parseISO, addMinutes } from "date-fns";
import firestore from "@/firebase/firestore";
import storage from "@/firebase/storage";

import { MglMap, MglMarker } from "v-mapbox";
import MglGeocoderControl from "@geospoc/v-mapbox-geocoder";
import Mapbox from "mapbox-gl";
import DatePickerField from "@/components/Base/DatePickerField";
import TimePickerField from "@/components/Base/TimePickerField";
import timezones from "@/assets/CitiesAndTimeZones.json";
import reminders from "@/assets/reminders";
import { uuid } from "vue-uuid";
import mbAPI from "@/APIS/mapbox-api";
import _ from "lodash";

import { quillEditor } from "vue-quill-editor";

// eslint-disable-next-line import/no-extraneous-dependencies
import "quill/dist/quill.snow.css";

export default {
  name: "ExcelUploadEvent",
  props: ["excelEvent", "editEvent", "users"],
  components: {
    DatePickerField,
    TimePickerField,
    MglGeocoderControl,
    MglMap,
    MglMarker,
    quillEditor,
  },
  data(a) {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["clean"],
            ["link"],
          ],
        },
        theme: "snow",
        placeholder: a.$t("common.description"),
      },

      marker: null,

      newEvent: null,
      mapCenter: [0, 0],
      mapZoom: 0,
      eventDate: new Date().toISOString().substr(0, 10),
      eventTime: null,
      formValid: false,

      checkOutTime: null,
      checkOutDate: null,

      eventDuration: null,
      invitedUsers: null,
      subgroups: [],
      mapDialog: false,

      reminders: reminders.options(this.$i18n),
      privacy: [
        {
          value: 2,
          text: this.$i18n.t("common.privacy.everyone.text"),
          hint: this.$i18n.t("common.privacy.everyone.hint"),
        },
        {
          value: 1,
          text: this.$i18n.t("common.optional"),
          hint: this.$i18n.t("common.privacy.optional.hint"),
        },
        {
          value: 3,
          text: this.$i18n.t("common.selected"),
          hint: this.$i18n.t("common.privacy.selected.hint"),
        },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        isUrl: (value) => {
          const regex =
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
          return !value || regex.test(value) || "Please enter a valid Url";
        },
      },
      usersMenu: false,
      feedback: null,
      file: null,
      imageSrc: null,
      saving: false,
      timezone: null,
      isRemote: false,
    };
  },
  methods: {
    onEditorReady(quill) {
      console.log("onEditorReady");
      console.log(quill);
      if (this.newEvent.quill_description) {
        console.log("Quill description");
        quill.setContents(JSON.parse(this.newEvent.quill_description).ops);
      } else {
        console.log("Description");
        quill.setText(this.newEvent.description);
      }
    },
    updateUserSubgroups(invitedUsers, subgroups, privacy, reminder) {
      this.newEvent.privacy = Math.min(privacy, 3);
      this.newEvent.reminder = reminder;
      if (privacy === 3) {
        this.subgroups = subgroups;
      } else if (privacy === 4) {
        this.invitedUsers = invitedUsers;
      }
    },
    toBoolArray(object) {
      if (!object) return null;
      return object.reduce((obj, id) => {
        // eslint-disable-next-line no-param-reassign,indent
        obj[id] = true;
        return obj;
      }, {});
    },
    handleSave() {
      console.log("saving event");
      if (!this.formValid) {
        return;
      }
      const tripId = this.$store.getters.currentTripId;

      const localDate = parseISO(`${this.eventDate} ${this.eventTime}`);

      if (this.isRemote) {
        this.newEvent.remote_tz = this.timezone.timezone;

        this.newEvent.attendance = false;
        delete this.newEvent.location.coordinates;
        delete this.newEvent.location.address;
        delete this.newEvent.location.time_zone;
        this.newEvent.time_zone = firestore.fieldDelete();
        // if(this.newEvent.meeting_url == null){
        //     delete this.newEvent.meeting_url
        // }
        const tzDifference = this.timezone.offset + localDate.getTimezoneOffset();

        this.newEvent.location.date = new Date(localDate.getTime() - tzDifference * 60 * 1000);
      } else {
        delete this.newEvent.remote_tz;
        this.newEvent.time_zone = "UTC";
        this.newEvent.location.date = new Date(
          localDate.getTime() - localDate.getTimezoneOffset() * 60 * 1000,
        );
        this.newEvent.location.coordinates = firestore.getGeo(this.newEvent.location.coordinates);
      }

      if (this.newEvent.hotel) {
        const checkOut = parseISO(`${this.checkOutDate} ${this.checkOutTime}`);
        const duration = (checkOut.getTime() - localDate.getTime()) / 60000;

        if (duration < 0) {
          this.feedback = this.$t("itinerary.NewEvent.feedBack2");
          return;
        }
        this.newEvent.duration = duration;
      } else if (this.eventDuration) {
        console.log("this eventt has durattion");
        const duration = new Date(`1970-01-01T${this.eventDuration}`);
        const durMinutes = duration.getMinutes() + duration.getHours() * 60;
        if (durMinutes > 0) {
          this.newEvent.duration = durMinutes;
        }
      }

      if (this.newEvent.privacy === 3) {
        if (
          (this.subgroups == null || this.subgroups.length === 0) &&
          (this.invitedUsers == null || this.invitedUsers.length === 0)
        ) {
          this.feedback = this.$t("itinerary.NewEvent.feedBack3");
          return;
        }
        this.newEvent.users = this.toBoolArray(this.invitedUsers);
        this.newEvent.subgroups = this.toBoolArray(this.subgroups);
      }

      let id;
      if (this.$props.editEvent) {
        id = this.$props.editEvent.id;
      }
      this.saving = true;

      this.newEvent.quill_description = JSON.stringify(
        this.$refs.myQuillEditor.quill.getContents(),
      );
      this.newEvent.description = this.$refs.myQuillEditor.quill.getText();
      firestore.writeTrackedDocument(tripId, "events", this.newEvent, id).then((docRef) => {
        if (docRef) {
          id = docRef.id;
        }

        console.log("Document written with ID: ", id);

        if (this.file) {
          console.log("saving image file");

          const name = `${uuid.v4()}.${this.file.name.split(".").pop().toLowerCase()}`;
          const firPath = `groups/${tripId}/images/${name}`;

          storage.uploadFile(this.file, firPath).then((snapshot) => {
            console.log("Uploaded a blob or file!", snapshot);
            firestore.writeTrackedDocument(
              tripId,
              "events",
              {
                "files.header": firPath,
              },
              id,
            );
            this.saving = false;
            this.$emit("remove", true);
          });
        } else {
          console.log("no image, exit");
          this.saving = false;
          this.$emit("remove", true);
        }
      });
    },
    removePin() {
      this.$delete(this.newEvent.location, "coordinates");
      this.$delete(this.newEvent.location, "address");
      this.$delete(this.newEvent.location, "wiki_code");
      this.$delete(this.newEvent.location, "time_zone");
      this.marker = null;
      this.mapDialog = false;
    },
    handleDelete() {
      console.log("deleting event");
      this.$emit("remove", false);
    },
    selectedItem(event) {
      console.log("selected item");
      console.log(event.result);

      const wikiCode =
        event.result.properties.wikiData ||
        event.result.context.find((context) => context.wikidata).wikidata;

      this.marker = {
        coordinates: event.result.center,
        address: event.result.place_name,
        wiki_code: wikiCode,
      };
    },
    mapLoaded(payload) {
      console.log("map loaded!");

      if (this.newEvent.location.coordinates) {
        this.marker = {
          coordinates: [
            this.newEvent.location.coordinates.long,
            this.newEvent.location.coordinates.lat,
          ],
          address: this.newEvent.location.address,
        };
      }

      payload.map.on("click", (e) => {
        const { lngLat } = e;

        console.log("clicked on", lngLat);

        this.marker = { coordinates: [lngLat.lng, lngLat.lat] };

        mbAPI.reverseGeocode(lngLat.lat, lngLat.lng).then((result) => {
          console.log("reversGeocode->", result);

          this.$set(this.marker, "address", result.name);
          this.$set(this.marker, "wiki_code", result.wiki_code);
        });
      });
    },
    saveNewPoint() {
      this.mapDialog = false;
      if (this.marker) {
        this.newEvent.location.coordinates = false;
        this.newEvent.location.address = this.marker.address;
        this.newEvent.location.wiki_code = this.marker.wiki_code;
        this.newEvent.location.coordinates = {
          lat: this.marker.coordinates[1],
          long: this.marker.coordinates[0],
        };

        mbAPI
          .getTimezone(this.marker.coordinates[0], this.marker.coordinates[1])
          .then((timezone) => {
            this.newEvent.location.time_zone = timezone;
          });
      }
    },
    setupEditEvent(event) {
      console.log("setupEditEvent(,", event);
      this.newEvent = {
        name: event.name,
        reminder: event.reminder,
        description: event.description,
        quill_description: event.quill_description,
        alarm: event.alarm,
        location: _.clone(event.location),
        privacy: event.privacy,
        feedback: event.feedback,
        attendance: event.attendance,
        // time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hotel: event.hotel,
      };

      if (event.location.coordinates) {
        this.newEvent.location.coordinates = {
          lat: event.location.coordinates.latitude,
          long: event.location.coordinates.longitude,
        };

        this.mapCenter = [
          this.newEvent.location.coordinates.long,
          this.newEvent.location.coordinates.lat,
        ];
        this.mapZoom = 13;
      }
      let date = event.location.date.toDate();

      if (event.remote_tz) {
        this.isRemote = true;
        this.newEvent.remote_tz = event.remote_tz;
        if (event.meeting_url) {
          this.newEvent.meeting_url = event.meeting_url;
        }
        this.timezone = this.timeZones.find((t) => t.timezone === event.remote_tz);
        const tzDifference = this.timezone.offset + date.getTimezoneOffset();
        date = new Date(date.getTime() + tzDifference * 60 * 1000);
      } else {
        date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      }

      this.eventDate = format(date, "yyyy-MM-dd");
      this.eventTime = format(date, "HH:mm");
      if (event.privacy === 3) {
        this.invitedUsers = Object.keys(event.users);
        this.subgroups = Object.keys(event.subgroups);
      }
      if (event.duration) {
        if (!event.hotel) {
          const t = new Date(1970, 0, 1); // Epoch
          t.setMinutes(event.duration);
          this.eventDuration = format(t, "HH:mm");
          console.log(
            `editing event with mins duration ${event.duration}, h:m->${this.eventDuration}`,
          );
          this.newEvent.duration = event.duration;
        } else {
          const checkOut = addMinutes(date, event.duration);
          this.checkOutDate = format(checkOut, "yyyy-MM-dd");
          this.checkOutTime = format(checkOut, "HH:mm");
        }
      }
    },

    setupExcelEvent(event) {
      console.log("1");
      console.log(event);
      this.newEvent = {
        name: event.name,
        description: event.description,
        reminder: event.reminder,
        alarm: event.alarm,
        location: event.location,

        privacy: 2,
        feedback: false,
        attendance: false,
        hotel: false,
      };

      this.eventDate = format(event.location.date, "yyyy-MM-dd");
      this.eventTime = format(event.location.date, "HH:mm");

      if (event.duration) {
        const t = new Date(1970, 0, 1); // Epoch
        t.setMinutes(event.duration);
        this.eventDuration = format(t, "HH:mm");
        this.newEvent.duration = event.duration;
      }
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          [this.file] = files;
          this.imageSrc = fr.result;
        });
      }
    },
  },
  computed: {
    timeZones() {
      return timezones;
    },
    mapboxgl() {
      return Mapbox;
    },
    accessToken() {
      return mbAPI.accessToken;
    },
    mapStyle() {
      return mbAPI.mapStyle;
    },
    privacyHint() {
      const { privacy } = this.newEvent;
      console.log(privacy);
      return this.privacy.filter((item) => item.value === privacy)[0].hint;
    },
    mapboxStaticImage() {
      const { coordinates } = this.newEvent.location;
      let url;
      if (coordinates.long != null) {
        url = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s(${coordinates.long},${coordinates.lat})/${coordinates.long},${coordinates.lat},15/700x350?access_token=${this.accessToken}`;
      }

      // console.log("url is", url);
      return url;
    },
    imageUrl() {
      const event = this.$props.editEvent;
      const img = event ? this.$store.state.imageUrls[event.id] : require("@/assets/other.jpg");
      return this.imageSrc || img || require("@/assets/other.jpg");
    },
    allUsers() {
      return this.$store.getters.allUsers;
    },
    allSubgroups() {
      return Object.values(this.$store.state.trip.subgroups);
    },
  },
  created() {
    const { excelEvent } = this.$props;
    console.log(excelEvent);
    if (excelEvent) {
      this.setupExcelEvent(excelEvent);
    } else {
      this.setupEditEvent(this.$props.editEvent);
    }
  },
  watch: {
    // eventTime(val) {
    //   this.newEvent.location.date = parseISO(`${this.eventDate} ${val}`);
    // },
    // eventDate(val) {
    //   this.newEvent.location.date = parseISO(`${val} ${this.eventTime}`);
    // },
    allUsers() {
      return this.$props.users;
    },
    eventDuration(val) {
      if (val) {
        console.log(val);
        const duration = new Date(`1970-01-01T${val}`);
        console.log(duration);
        this.newEvent.duration = duration.getMinutes() + duration.getHours() * 60;
      }
    },
  },
};
</script>
